import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {MvsCrudService} from "features/core/shared/service/crud/mvs-crud.service";
import {HelpTourDto} from "../../model/dto/help-tour.dto";

@Injectable({
    providedIn: 'root'
})
export class HelpTourService {

    private readonly apiUrl: string;

    constructor(private http: HttpClient) {
        this.apiUrl = MvsCrudService.baseUrl + '/cb/help/tours';
    }

    getTours(moduleAlias: string, role?: string): Observable<HelpTourDto[]> {
        let params = new HttpParams().set('moduleAlias', moduleAlias);
        if (role) {
            params = params.set('role', role);
        }
        return this.http.get<HelpTourDto[]>(this.apiUrl, {params});
    }

    getTour(id: number): Observable<HelpTourDto> {
        return this.http.get<HelpTourDto>(`${this.apiUrl}/${id}`);
    }

    getUncompletedTours(moduleAlias: string): Observable<HelpTourDto[]> {
        return this.http.get<HelpTourDto[]>(`${this.apiUrl}/uncompleted`, {
            params: new HttpParams().set('moduleAlias', moduleAlias)
        });
    }

    completeTour(id: number, lastStepIndex?: number): Observable<void> {
        let params = new HttpParams();
        if (lastStepIndex !== undefined) {
            params = params.set('lastStepIndex', lastStepIndex.toString());
        }
        return this.http.post<void>(`${this.apiUrl}/${id}/complete`, null, {params});
    }
}
